import { topic } from './studyToolTopicRule';
export const MATH_PHYSICS_TOPICS = [
  // Catalogue coverage only: the independent, unreviewed Lab is excluded from contextual recommendations.
  topic(
    'physics-lab',
    'physics lab|independent physics laboratory',
    '物理实验室|独立物理实验',
    'Explore prepared circuit and mechanics models in the independent full-screen lab; no assessment or in-Lab Tutor is provided.',
    'Open the independent physics laboratory to explore a prepared model.',
    '打开物理实验室，探索预设模型。',
  ),
  topic(
    'fraction-ratio-lab',
    'fraction|fractions|ratio|ratios|percentage|percent|equal parts|quarter|quarters|half|halves|numerator|denominator',
    '分数|等分|分子|分母|百分比|比例',
    'Move the equal parts and compare the fraction, decimal and percentage.',
    'Split a whole into equal parts and compare three quarters with one half.',
    '把整体等分后，比较四分之三与二分之一这两个分数。',
  ),
  topic(
    'algebra-machine',
    'linear equation|balance an equation|algebra|solve for x',
    '一元一次方程|方程平衡|代数',
    'Try the same operation on both sides and see why an equation stays balanced.',
    'Subtract the same amount from both sides of a linear equation.',
    '一元一次方程两边同时减去相同的数，保持方程平衡。',
  ),
  topic(
    'simultaneous-equations',
    'simultaneous equations|system of equations|common solution',
    '联立方程|方程组|公共解',
    'Compare equations and look for the solution they share.',
    'Find the common solution of this system of equations.',
    '找出方程组中两条直线共同的解。',
  ),
  topic(
    'functions-graphs',
    'function graph|functions|gradient|slope|intercept|function rule',
    '函数图像|函数|斜率|截距',
    'Change a rule and connect its graph with a table of values.',
    'The gradient changes as the function graph becomes steeper.',
    '改变函数的斜率，观察函数图像怎样变化。',
  ),
  topic(
    'quadratic-solver',
    'quadratic|discriminant|parabola|quadratic roots',
    '二次方程|判别式|抛物线',
    'Change the coefficients and compare the roots with the curve.',
    'Use the discriminant to explain how many quadratic roots are real.',
    '用判别式解释二次方程有几个实数根。',
  ),
  topic(
    'geometry-measurement',
    'perimeter|surface area|volume of a|area of a',
    '周长|表面积|体积|面积',
    'Resize a shape and connect its measurements with the formula.',
    'Compare the perimeter and area of a rectangle as its width changes.',
    '改变长方形宽度，比较周长与面积。',
  ),
  topic(
    'coordinate-transformations',
    'coordinate transformation|reflection|translation|rotation|dilation',
    '坐标变换|轴对称|平移|旋转|位似',
    'Move a shape on axes and compare the original and transformed coordinates.',
    'Predict the new coordinates after a reflection across the y axis.',
    '预测图形关于纵轴作轴对称后的坐标。',
  ),
  topic(
    'coordinate-distance',
    'distance between two points|coordinate distance|straight-line distance',
    '两点间距离|坐标距离|直线距离',
    'Build a right triangle between two points to find their distance.',
    'Find the distance between two points using horizontal and vertical changes.',
    '用横纵坐标之差求两点间距离。',
  ),
  topic(
    'angles-trigonometry',
    'trigonometry|pythagoras|sine|cosine|right triangle',
    '三角函数|勾股|正弦|余弦',
    'Build a triangle and compare its sides and angles.',
    'Use sine to connect an angle with two sides of a right triangle.',
    '在直角三角形中，用正弦联系角度与边长。',
  ),
  topic(
    'sequences-growth',
    'arithmetic sequence|geometric sequence|sequence rule|exponential growth',
    '等差数列|等比数列|数列规律|指数增长',
    'Change a sequence and compare repeated addition with repeated multiplication.',
    'Compare an arithmetic sequence with a geometric sequence over five terms.',
    '比较等差数列与等比数列前五项的变化。',
  ),
  topic(
    'logarithm-explorer',
    'logarithm|logarithms|inverse exponent|log base',
    '对数|指数的逆运算',
    'Use a power table to see which exponent a logarithm asks for.',
    'A logarithm asks which exponent gives the number.',
    '对数是在问：哪个指数能得到这个数？',
  ),
  topic(
    'indices-powers',
    'exponent rule|indices|powers|laws of indices|common base',
    '指数法则|幂运算|同底数|指数运算',
    'Compare powers and test index rules with the same base.',
    'Multiply powers with a common base and explain the exponent rule.',
    '解释同底数幂相乘时的指数法则。',
  ),
  topic(
    'money-models',
    'compound interest|simple interest|discount|percentage discount',
    '复利|单利|折扣|打折',
    'Compare discounts and how money changes under simple or compound interest.',
    'Compare simple interest and compound interest over several years.',
    '比较同一笔钱按单利和复利增长的区别。',
  ),
  topic(
    'rates-calculus',
    'derivative|integral|differentiation|tangent gradient|rate of change',
    '导数|积分|微分|切线斜率|变化率',
    'Move along a function and compare its tangent and accumulated area.',
    'The derivative describes the rate of change at this point.',
    '用导数解释函数在这一点的变化率。',
  ),
  topic(
    'data-probability',
    'probability|median|arithmetic mean|mean value|mean of|histogram|statistics',
    '概率|中位数|平均数|统计|直方图',
    'Compare data or chance with a visual model before trying again.',
    'Compare the median and arithmetic mean of these observations.',
    '比较这组数据的中位数与平均数。',
  ),
  topic(
    'formulas',
    'unit conversion|significant figures|dimensional analysis|physical constants',
    '单位换算|有效数字|量纲分析|物理常量',
    'Rearrange a physics formula and check its units and significant figures.',
    'Convert the measurement into SI units using unit conversion.',
    '先做单位换算，再按有效数字写出结果。',
  ),
  topic(
    'motion-graphs',
    'kinematics|velocity|acceleration|displacement|motion graph',
    '运动学|速度|加速度|位移',
    'Connect a journey with position, velocity and acceleration graphs.',
    'Compare velocity and displacement during constant acceleration.',
    '比较匀加速运动中的速度与位移。',
  ),
  topic(
    'vectors-forces',
    'net force|resultant force|force diagram|force components|vectors',
    '合力|受力图|力的分解|向量',
    'Combine force arrows and see how direction changes the resultant.',
    'Draw the force components before calculating the resultant force.',
    '先画受力图，再求各方向上的合力。',
  ),
  topic(
    'projectile',
    'projectile|projectiles|launch angle|horizontal launch|thrown ball',
    '抛体运动|平抛|斜抛|发射角',
    'Change the launch and compare horizontal and vertical motion.',
    'For a projectile, compare horizontal speed and vertical acceleration.',
    '在平抛运动中分别观察水平速度与竖直加速度。',
  ),
  topic(
    'light',
    'refraction|snell|critical angle|total internal reflection',
    '折射|斯涅尔|临界角|全反射',
    'Move a light ray between materials and test when it bends or reflects.',
    'Increase the angle of incidence until total internal reflection occurs.',
    '增大入射角，观察临界角与全反射。',
  ),
  topic(
    'half-life',
    'half-life|radioactive decay|medical isotope|unstable atoms',
    '半衰期|放射性衰变|医用同位素',
    'Compare random decay with the amount expected after each half-life.',
    'After one half-life, compare the radioactive atoms remaining.',
    '经过一个半衰期后，比较剩余的放射性原子数。',
  ),
  topic(
    'circuits',
    'circuit|voltage|resistance|electric current',
    '电路|电压|电阻|电流',
    'Change a circuit and compare its current and voltage.',
    'Compare the current in series and parallel circuits.',
    '比较串联与并联电路中的电流。',
  ),
  topic(
    'waves',
    'wavelength|frequency|wave speed|sound wave',
    '波长|频率|波速|声波',
    'Change a wave and compare wavelength, frequency and speed.',
    'Explain why wave speed equals frequency times wavelength.',
    '解释波速、频率与波长之间的关系。',
  ),
  topic(
    'energy',
    'kinetic energy|potential energy|energy transfer|energy conservation',
    '动能|势能|能量转移|机械能守恒',
    'Follow a moving skater and compare stored, moving and thermal energy.',
    'As height falls, gravitational potential energy becomes kinetic energy.',
    '高度降低时，重力势能如何转化为动能？',
  ),
  topic(
    'electromagnetism',
    'electromagnetic induction|magnetic flux|motor effect|solenoid',
    '电磁感应|磁通量|电动机效应|螺线管',
    'Compare magnetic fields, forces and induced changes in the experiment preview.',
    'Changing magnetic flux induces a voltage in the coil.',
    '线圈中的磁通量变化会产生电磁感应。',
  ),
  topic(
    'thermal',
    'specific heat capacity|thermal equilibrium|latent heat',
    '比热容|热平衡|潜热',
    'Compare temperature and transferred energy in the thermal experiment preview.',
    'Compare temperature changes using specific heat capacity.',
    '用比热容比较相同热量导致的温度变化。',
  ),
  topic(
    'momentum',
    'momentum|impulse|collision conservation',
    '动量|冲量|碰撞守恒',
    'Compare before and after a collision and connect force with impulse.',
    'Compare total momentum before and after a collision.',
    '比较碰撞前后的总动量。',
  ),
  topic(
    'circular-gravity',
    'centripetal|circular motion|orbital motion|gravitational orbit',
    '向心力|圆周运动|轨道运动',
    'Change the orbit or circle and compare the inward acceleration.',
    'An object in circular motion needs centripetal acceleration.',
    '圆周运动需要指向圆心的向心加速度。',
  ),
  topic(
    'modern-physics',
    'photoelectric|energy levels|special relativity|photon energy',
    '光电效应|能级|狭义相对论|光子能量',
    'Compare evidence for photons, energy levels and relativity in the preview.',
    'The photoelectric effect depends on photon energy, not brightness alone.',
    '光电效应取决于光子能量，而不只是光的亮度。',
  ),
];
